import { ProcessMenu } from './menu-processing'
const menu = [
  [
    {
      title: 'Default',
      id: 'Default-32',
      type: 'group',
      children: [
        {
          title: 'Default',
          id: 'Default-46',
          type: 'collapse',
          claim: null,
          children: [
            {
              title: 'Home',
              id: 'Home-33',
              paths: ['/', '/:id', '/:id/:component'],
              hidden: false,
              targetView: 'Home',
              type: 'item',
            },
            {
              title: 'Add Profile',
              id: 'Add Profile-34',
              paths: ['/'],
              hidden: true,
              targetView: 'AddProfile',
              type: 'item',
            },
            {
              title: 'Edit Profile',
              id: 'Edit Profile-35',
              paths: ['/:id', '/:id/profile-image'],
              hidden: true,
              targetView: 'EditProfile',
              type: 'item',
            },
            {
              title: 'Select Profile',
              id: 'Select Profile-36',
              paths: ['/', '/profile-image'],
              hidden: false,
              targetView: 'SelectProfile',
              type: 'item',
            },
            {
              title: 'Select Edit Profile',
              id: 'Select Edit Profile-37',
              paths: ['/'],
              hidden: true,
              targetView: 'EditProfileSelect',
              type: 'item',
            },
            {
              title: 'Watch',
              id: 'Watch-38',
              paths: [
                '/',
                '/:id',
                '/:id/:media',
                '/:id/:media/:approvedMediaId',
              ],
              hidden: false,
              targetView: 'Watch',
              type: 'item',
            },
            {
              title: 'Mobile Login',
              id: 'Mobile Login-39',
              paths: ['/'],
              hidden: false,
              targetView: 'MobileLogin',
              type: 'item',
            },
            {
              title: 'Support',
              id: 'Support-40',
              paths: ['/'],
              hidden: true,
              targetView: 'Support',
              type: 'item',
            },
            {
              title: 'Mobile Connect',
              id: 'Mobile Connect-41',
              paths: ['/'],
              hidden: true,
              targetView: 'MobileConnect',
              type: 'item',
            },
            {
              title: 'playwatchkidsmobile',
              id: 'playwatchkidsmobile-42',
              paths: ['/', '/:id'],
              hidden: true,
              targetView: 'playwatchkidsmobile',
              type: 'item',
            },
            {
              title: 'Search',
              id: 'Search-43',
              paths: ['/'],
              hidden: false,
              targetView: 'Search',
              type: 'item',
            },
            {
              title: 'PGCPS',
              id: 'PGCPS-44',
              paths: ['/'],
              hidden: true,
              targetView: 'PGCPS',
              type: 'item',
            },
            {
              title: 'Home',
              id: 'Home-45',
              paths: [
                '/',
                '/:id',
                '/:id/:media',
                '/:id/:media/:approvedMediaId',
              ],
              hidden: true,
              targetView: 'Home',
              type: 'item',
            },
          ],
          script: '',
        },
      ],
    },
  ],
]
export default ProcessMenu(menu)
